import { CellDep, KnownScript, ScriptInfo } from "@ckb-ccc/core";

export const DEVNET_SCRIPTS: Record<KnownScript, ScriptInfo> = {
  [KnownScript.AlwaysSuccess]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.EasyToDiscoverType]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.InputTypeProxyLock]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.LockProxyLock]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.NervosDao]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.NostrLock]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.OutputTypeProxyLock]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.PWLock]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.SingleUseLock]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.TimeLock]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.TypeBurnLock]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.TypeId]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.UniqueType]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.XUdt]: {
    cellDeps: [],
    codeHash:
      "0x0000000000000000000000000000000000000000000000000000000000000000",
    hashType: "type",
  },
  [KnownScript.Secp256k1Blake160]: {
    codeHash:
      "0x9bd7e06f3ecf4be0f2fcd2188b23f1b9fcc88e5d4b65a8637b17723bbda3cce8",
    hashType: "type",
    cellDeps: [],
  },
  [KnownScript.Secp256k1Multisig]: {
    codeHash:
      "0x5c5069eb0857efc65e1bca0c07df34c31663b3622fd3876c876320fc9634e2a8",
    hashType: "type",
    cellDeps: [],
  },
  [KnownScript.AnyoneCanPay]: {
    codeHash:
      "0x3419a1c09eb2567f6552ee7a8ecffd64155cffe0f1796e6e61ec088d740c1356",
    hashType: "type",
    cellDeps: [],
  },
  [KnownScript.JoyId]: {
    codeHash:
      "0xd23761b364210735c19c60561d213fb3beae2fd6172743719eff6920e020baac",
    hashType: "type",
    cellDeps: [],
  },
  [KnownScript.COTA]: {
    codeHash:
      "0x89cd8003a0eaf8e65e0c31525b7d1d5c1becefd2ea75bb4cff87810ae37764d8",
    hashType: "type",
    cellDeps: [],
  },
  [KnownScript.OmniLock]: {
    codeHash:
      "0x9c6933d977360f115a3e9cd5a2e0e475853681b80d775d93ad0f8969da343e56",
    hashType: "type",
    cellDeps: [
      {
        cellDep: CellDep.from({
          outPoint: {
            txHash:
              "0x6141d3dc3ccd8cbe4f0870676649778dd0f0422cf19735fcdebfa003fa980a40",
            index: 7n,
          },
          depType: "code",
        }),
      },
      {
        cellDep: CellDep.from({
          outPoint: {
            txHash:
              "0x3adf8c8bf04842c83cdaa21072cd3c4f869e8f7448b68d9baa409f6dc09f09b6",
            index: 0n,
          },
          depType: "depGroup",
        }),
      },
    ],
  },
};
